export default __webpack_public_path__ + "static/media/ananda.819d6630.png";